var map = {
	"./application5-1.jpg": "GVoi",
	"./application5-2.jpg": "gTs4",
	"./application5-3.jpg": "9otr",
	"./application5-4.jpg": "iFrs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bXRb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application5 ^\.\/.*$
// module id = bXRb
// module chunks = 0